import {ALGO_ASSET} from "@tinymanorg/tinyman-js-sdk";

// eslint-disable-next-line no-magic-numbers
const MIN_POOL_PRICE_RATIO = Math.pow(10, -ALGO_ASSET.decimals);

export {MIN_POOL_PRICE_RATIO};
